// @flow
import ResourceFactory from 'app/common/lib/ResourceFactory';

const reportInviteLand = (invite_code: string) =>
  ResourceFactory.create('InviteAttributionResource', {
    invite_code,
  }).callCreate();

export default reportInviteLand;
